import { render, staticRenderFns } from "./DispositionDetailView.vue?vue&type=template&id=78b8d127&"
import script from "./DispositionDetailView.vue?vue&type=script&lang=js&"
export * from "./DispositionDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports